import { authHeader, handleResponse } from '../helpers';
export const UserloyalityLogRptService = {
    fetchUserloyalityLogData   
};

function fetchUserloyalityLogData(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data)
    };

    return fetch(`${process.env.REACT_APP_API_URL}UserloyalityLogRpt/GetUserloyalityLogReport`, requestOptions)
        .then(handleResponse);
}